/**
 * @generated SignedSource<<d7767139f24b448b8e3af814def1dbce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileActions_Query$variables = {
  userId: string;
};
export type ProfileActions_Query$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"ProfileActions_User">;
  } | null | undefined;
  readonly freelancer: {
    readonly " $fragmentSpreads": FragmentRefs<"ProfileActions_Freelancer">;
  } | null | undefined;
};
export type ProfileActions_Query = {
  response: ProfileActions_Query$data;
  variables: ProfileActions_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfileActions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProfileActions_User"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "freelancer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileActions_Freelancer"
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProfileActions_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guest",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "realUser",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClient",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "freelancer",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canNotify",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canMakeOffer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isChatContact",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatThread",
                "kind": "LinkedField",
                "name": "directChatThread",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": "unreadMessages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filters",
                        "value": {
                          "unread": true
                        }
                      }
                    ],
                    "concreteType": "ChatMessageConnection",
                    "kind": "LinkedField",
                    "name": "chatMessages",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": "chatMessages(filters:{\"unread\":true})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChatMessageConnection",
                    "kind": "LinkedField",
                    "name": "chatMessages",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rawId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Profile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slug",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "self",
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d78b8df5d09555f8c095892ba3148eb",
    "id": null,
    "metadata": {},
    "name": "ProfileActions_Query",
    "operationKind": "query",
    "text": "query ProfileActions_Query(\n  $userId: ID!\n) {\n  currentUser {\n    ...ProfileActions_User\n    id\n  }\n  freelancer: node(id: $userId) {\n    __typename\n    ... on User {\n      ...ProfileActions_Freelancer\n    }\n    id\n  }\n}\n\nfragment ChatButton_ChatThread on ChatThread {\n  id\n  unreadMessages: chatMessages(filters: {unread: true}) {\n    totalCount\n  }\n  chatMessages {\n    totalCount\n  }\n}\n\nfragment ChatButton_Recipient on User {\n  id\n  firstName\n  self\n  directChatThread {\n    ...ChatButton_ChatThread\n    id\n  }\n}\n\nfragment MasqButton_User on User {\n  ...masq_masqAsUser\n}\n\nfragment NotifyAboutJob_User on User {\n  rawId\n  firstName\n  profile {\n    slug\n    id\n  }\n}\n\nfragment ProfileActions_Freelancer on User {\n  id\n  canNotify\n  canMakeOffer\n  isChatContact\n  directChatThread {\n    id\n  }\n  ...NotifyAboutJob_User\n  ...MasqButton_User\n  ...ChatButton_Recipient\n}\n\nfragment ProfileActions_User on User {\n  ...user_useIsGuest\n  ...user_useIsRealAdmin\n  ...user_useIsClient\n}\n\nfragment masq_masqAsUser on User {\n  id\n}\n\nfragment user_isClient on User {\n  status\n  isClient\n}\n\nfragment user_isGuest on User {\n  guest\n  status\n}\n\nfragment user_isRealAdmin on User {\n  roles\n  realUser {\n    roles\n    id\n  }\n}\n\nfragment user_useIsClient on User {\n  ...user_isClient\n}\n\nfragment user_useIsGuest on User {\n  ...user_isGuest\n}\n\nfragment user_useIsRealAdmin on User {\n  ...user_isRealAdmin\n}\n"
  }
};
})();

(node as any).hash = "7b4ff8a69299d5a220947f968073a763";

export default node;
